// import { Routes, Route } from "react-router-dom";

//auth pages
import ConfirmMail from "../views/backend/Auth/ConfirmMail";
import LockScreen from "../views/backend/Auth/LockScreen";
import RecoverPassword from "../views/backend/Auth/RecoverPassword";
import SignIn from "../views/backend/Auth/SignIn";
import SignUp from "../views/backend/Auth/SignUp";

//ExtarPages
import Error404 from "../views/backend/pages/Error/Error404";
import Error500 from "../views/backend/pages/Error/Error500";

import BlankLayout from "../layouts/BlankLayout";
import ResetPassword from "../views/backend/Auth/ResetPassword";

export const ExtraPages = [
  {
    path: "/auth",
    element: <BlankLayout />,
    children: [
      {
        path: "confirm-mail",
        element: <ConfirmMail />,
      },
      {
        path: "lock-screen",
        element: <LockScreen />,
      },
      {
        path: "recoverpw",
        element: <RecoverPassword />,
      },
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
      {
        path: "reset-password/:email/:token",
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: "/extra-pages",
    element: <BlankLayout />,
    children: [
      {
        path: "pages-error",
        element: <Error404 />,
      },
      {
        path: "pages-error-500",
        element: <Error500 />,
      },
    ],
  },
];
